/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */

import React from "react";
import { Col, Row } from "antd";
import {
  getMenuParentElements,
  getParentMenuChildren,
  toggleCookieSettings,
} from "../../menuHelpers";
import MuotolevyDesktopMenu from "./MuotolevyDesktopMenu";
import SideNav from "./SideNav";

// Desktop menu
export const DesktopMenu = (props) => {
  const { datalinks, parentMenu, sitemegamenu, sitemegamenumuotolevy } = props;
  const { menuChildren, menuChildrenWithChildren, menuHasNoGrandChildren } =
    getParentMenuChildren(
      sitemegamenu.concat(sitemegamenumuotolevy), // NOTE: concat megamenu and muotolevy-menu
      parentMenu.ID,
    );
  if (menuChildren.length === 0) return null;
  const [muotolevyParentMenu] = getMenuParentElements(sitemegamenumuotolevy);
  // NOTE: if muotolevy menu is active, render muotolevy menu
  if (muotolevyParentMenu && parentMenu.ID === muotolevyParentMenu.ID) {
    return (
      <MuotolevyDesktopMenu sitemegamenumuotolevy={sitemegamenumuotolevy} />
    );
  }
  return (
    <div className="megamenu__wrapper">
      <div className="megamenu__container">
        <Row gutter={64}>
          <Col span={16}>
            <Row gutter={32} style={{ width: "100%" }}>
              <ul style={{ width: "100%" }}>
                <li className="highlight-item">
                  <a
                    role={parentMenu.url.startsWith("http") ? "link" : "button"}
                    href={parentMenu.url}
                  >
                    {parentMenu.title}
                  </a>
                </li>
              </ul>
            </Row>
            <Row gutter={32} style={{ width: "100%" }}>
              {!menuHasNoGrandChildren && (
                <Col span={12}>
                  <ul>
                    {menuChildrenWithChildren.map((item) => (
                      <li className={`${item.classes[0]} no-border`}>
                        <span className="highlight-item-title">
                          {item.title}
                        </span>
                        {item.children && (
                          <ul>
                            {item.children.map((child) => (
                              <li
                                className={`${child.classes[0]} no-border bold`}
                              >
                                <a href={child.url}>{child.title}</a>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                  </ul>
                </Col>
              )}
              <Col span={12}>
                <ul>
                  {menuChildren.map((item) => (
                    <li className={`${item.classes[0]} no-border`}>
                      <a href={item.url}>{item.title}</a>
                    </li>
                  ))}
                </ul>
              </Col>
            </Row>
          </Col>
          <Col style={{ display: "flex" }} span={8}>
            <SideNav {...props} />
          </Col>
        </Row>
        <Row gutter={64}>
          <Col flex={1}>
            <div className="megamenu__footer">
              {datalinks && (
                <ul>
                  {datalinks.map((item, index, array) =>
                    index === array.length - 1 ? (
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            toggleCookieSettings();
                          }}
                        >
                          {item.title}
                        </a>
                      </li>
                    ) : (
                      <li>
                        <a href={item.url}>{item.title}</a>
                      </li>
                    ),
                  )}
                </ul>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default DesktopMenu;
